<div class="error-fallback-container">
  <div class="error-card">
    <div class="error-icon-container">
      <ng-icon [name]="getErrorIcon()" class="error-icon" size="4.5rem"></ng-icon>
    </div>
    
    <h1 class="error-title">Authentication Error</h1>
    
    <p class="error-message">{{ errorMessage }}</p>
    
    <div class="error-details" *ngIf="errorDetails">
      <p>{{ errorDetails }}</p>
    </div>

    <div class="error-actions">
      <button 
        mat-raised-button 
        color="primary" 
        (click)="retryLogin()" 
        *ngIf="showRetry && errorType === 'oauth2_callback'"
        class="action-button">
        <!-- <ng-icon name="heroArrowPath" class="mr-2" size="1.5rem"></ng-icon> -->
        <span>Retry Login with Microsoft</span>
      </button>
      
      <button 
        mat-raised-button 
        color="accent" 
        (click)="goToLogin()" 
        *ngIf="showBackToLogin"
        class="action-button">
        <!-- <ng-icon name="heroArrowLeft" class="mr-2" size="1.5rem"></ng-icon> -->
        <span>Back to Login</span>
      </button>
<!-- 
      <button 
        mat-stroked-button 
        color="primary" 
        (click)="goToDashboard()" 
        class="action-button">
        <ng-icon name="heroHome" class="mr-2"></ng-icon>
        Go to Dashboard
      </button>
    </div> -->

    <div class="error-help" *ngIf="errorType === 'oauth2_callback'">
      <p class="help-text">
        <strong>Need help?</strong> If this problem persists, please contact your system administrator.
      </p>
    </div>
  </div>
</div>

